module.exports = __webpack_public_path__ + "img/map_Z1.2.C.03.84df1bed.svg";